import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash.get';

import ValidationMessage from '../ValidationMessage';
import InputWrapper from '../InputWrapper';
import InputLabel from '../InputLabel';
import {
  inputBooleanTypes,
  INPUT_BOOLEAN_VARIANTS,
  INPUT_BOOLEAN_CHECKBOX
} from './InputBooleanBase';

const InputBooleanGroup = props => {
  const {
    name,
    items,
    type,
    onChange,
    onBlur,
    validationState,
    validationMessage,
    isRequired,
    label,
    variant,

    renderItems,

    /* groupProps */
    inputProps,
    inputWrapperProps,
    validationProps,
    inputLabelProps,
    itemWrapperProps,
    itemsWrapperProps,
    itemLabelProps
  } = props;

  return (
    <InputWrapper
      {...inputWrapperProps}
      validationState={validationState}
      className={classnames(
        'input--boolean',
        variant === INPUT_BOOLEAN_VARIANTS.flexible &&
          'input--flexible-boolean',
        variant === INPUT_BOOLEAN_VARIANTS.fixed && 'input--fixed-boolean',
        get(inputWrapperProps, 'className')
      )}
      label={label}
      isRequired={isRequired}
      inputLabelProps={inputLabelProps}
    >
      <div
        {...itemsWrapperProps}
        className={classnames(
          'input__boolean-wrapper',
          type === INPUT_BOOLEAN_CHECKBOX && 'input--square',
          get(itemsWrapperProps, 'className')
        )}
      >
        {items.map((item, index) => {
          const {
            label: itemLabel,
            value: itemValue,
            itemLabelProps: specificItemLabelProps,
            ...otherItemProps
          } = item;

          const itemId = `${name}_${index}`;

          return (
            <div
              {...itemWrapperProps}
              key={`itemItem_${index}`}
              className={classnames(
                variant === INPUT_BOOLEAN_VARIANTS.regular && 'input__row',
                get(itemWrapperProps, 'className')
              )}
            >
              {renderItems({
                ...inputProps,
                ...otherItemProps,
                itemValue,
                itemId,
                type,
                name,
                onBlur,
                onChange
              })}

              <InputLabel
                htmlFor={itemId}
                {...itemLabelProps}
                {...specificItemLabelProps}
              >
                {itemLabel}
              </InputLabel>
            </div>
          );
        })}
      </div>
      <ValidationMessage validationState={validationState} {...validationProps}>
        {validationMessage}
      </ValidationMessage>
    </InputWrapper>
  );
};

InputBooleanGroup.propTypes = {
  name: PropTypes.string,
  isRequired: PropTypes.bool,
  items: PropTypes.array.isRequired,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  renderItems: PropTypes.func,
  type: PropTypes.oneOf(inputBooleanTypes),
  validationMessage: PropTypes.string,
  validationState: PropTypes.oneOf(['success', 'warning', 'error', undefined]),
  variant: PropTypes.oneOf(Object.keys(INPUT_BOOLEAN_VARIANTS)),

  /* Components props */
  inputProps: PropTypes.object,
  inputWrapperProps: PropTypes.object,
  validationProps: PropTypes.object,
  inputLabelProps: PropTypes.object,
  itemWrapperProps: PropTypes.object,
  itemsWrapperProps: PropTypes.object,
  itemLabelProps: PropTypes.object
};

export function variantPropTypeValidation(props) {
  if (props.inline === true && !props.variant) {
    return new Error('When "inline" is true, "variant" is required');
  }
  const variantKeys = Object.keys(INPUT_BOOLEAN_VARIANTS);

  if (!variantKeys.includes(props.variant)) {
    return new Error(`Variant must be one of [${variantKeys.join(', ')}]`);
  }
  return null;
}

export default InputBooleanGroup;
